module.exports = __webpack_public_path__ + "static/image/font/pc/bmhanna11yrs-3@3x.jpg?fd9d0495";